export const wflowRequest = {
    baseUrl: "https://prod.api.wacker.com/wflow/v1/api/"

};